<template>
  <pt-adult-sell-order-form ref="form" class="pt-adult-sell-order-form__withData"></pt-adult-sell-order-form>
</template>

<script>
import PtAdultSellOrderForm from './index'
export default {
  name: 'pt-adult-sell-order-form__withData',
  components: {
    'pt-adult-sell-order-form': PtAdultSellOrderForm
  },
  computed: {
    form () {
      return this.$refs.form
    }
  },
  methods: {
    submit () {
      this.form.validate().then(formValue => {
        this.$store.dispatch('').then(data => {
          // doing something ...
        }).catch(errorMessage => {
          console.error(errorMessage)
          this.$message.error(errorMessage)
        })
      })
    }
  }
}
</script>
